import { useCallback, useEffect, useState } from "react";

/**
 * Instalar la web como app en el celular o el escritorio (PWA).
 *
 * Chrome, Edge y los demas navegadores Chromium lanzan beforeinstallprompt
 * cuando la web se puede instalar: HTTPS y un manifest.json con nombre,
 * iconos de 192 y 512 y display standalone. Se guarda el evento y, al pulsar
 * el boton, prompt() abre la ventana de instalacion del sistema.
 *
 * El evento se escucha al cargar este modulo y no al montar el componente:
 * puede llegar antes de que exista la barra superior, por ejemplo en la
 * pantalla de inicio de sesion.
 *
 * Safari (iPhone) no tiene este evento: alli el boton no aparece y se instala
 * desde Compartir > Anadir a pantalla de inicio.
 */
let eventoInstalacion = null;
const suscriptores = new Set();

const avisar = () => suscriptores.forEach((fn) => fn(eventoInstalacion != null));

if (typeof window !== "undefined") {
    window.addEventListener("beforeinstallprompt", (e) => {
        // Sin esto Chrome muestra su propio aviso; el boton lo sustituye.
        e.preventDefault();
        eventoInstalacion = e;
        avisar();
    });

    window.addEventListener("appinstalled", () => {
        eventoInstalacion = null;
        avisar();
    });
}

const useInstalarApp = () => {
    const [puedeInstalar, setPuedeInstalar] = useState(eventoInstalacion != null);

    useEffect(() => {
        suscriptores.add(setPuedeInstalar);
        setPuedeInstalar(eventoInstalacion != null);

        return () => { suscriptores.delete(setPuedeInstalar); };
    }, []);

    const instalar = useCallback(async () => {
        if (!eventoInstalacion) return;

        const evento = eventoInstalacion;
        evento.prompt();
        await evento.userChoice;

        // Un evento solo se puede usar una vez, se acepte o no. Si se
        // cancela, Chrome lanza otro mas adelante y el boton vuelve.
        eventoInstalacion = null;
        avisar();
    }, []);

    return { puedeInstalar, instalar };
};

export default useInstalarApp;
